import {Bar, Container} from './styled';

interface Props {
  totalSteps: number;
  currentStep: number;
  className?: string;
}

function OnboardingStepsProgress({totalSteps, currentStep, className}: Props) {
  return (
    <Container className={className}>
      {Array.from({length: totalSteps}).map((_, idx) => (
        <Bar key={idx} $active={idx < currentStep} />
      ))}
    </Container>
  );
}

export {OnboardingStepsProgress};
